import { h } from 'preact'
import styles from './header.module.css'

export const Header = ({ isLive, title, hideSubtitle }) => (
  <div class={styles.header}>
    <h1 className={styles.title}>{title}</h1>
    {!hideSubtitle && <div className={styles.saken}>Dette er saken</div>}
    {isLive && (
      <div className={styles.updating}>
        <span className={styles.dot} />
        <span>Oppdateres</span>
      </div>
    )}
  </div>
)
